// import moment from "moment";
import moment from "moment-timezone";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import { Puff, Oval } from "react-loader-spinner";
import imageCompression from 'browser-image-compression';

import Viewer from "react-viewer";
import {
  formatDate,
  getAvatarUrl,
  getImageUrl,
  getRealFileName,
  getServiceTicketUrl,
  getUploadUrl,
  UtcToMst,
} from "src/Common/common";
import {
  downloadImage,
  downloadPdf,
  handleError,
  isAccountant,
  isAdmin,
  isClericalOver,
  isManagerOver,
} from "src/Common/function";
import Button from "src/Components/Button";
import ApproveRequestButton from "src/Components/Common/approverequestbutton";
import BlueButton from "src/Components/Common/bluebutton";
import DenyRequestButton from "src/Components/Common/denyrequestbutton";
import PencilButton from "src/Components/Common/pencilbutton";
import WhiteUploadButton from "src/Components/Common/whiteuploadbutton";
import CreateButton from "src/Components/CreateButton";
import { setWONumber } from "src/Redux/Slices/HeaderSlice";
import POService from "src/Services/API/po.service";
import TechnicianService from "src/Services/API/technician.service";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import AssignTechModal from "./Components/AssignTech/assigntechmodal";
import ScheduleModal from "./Components/ScheduleModal";
import WOStatusComponent from "./Components/Status/wostatuscomponent";
import BilledDateModal from "./Components/billeddatemodal";
import CreateWoModal from "./Components/createwomodal";
import CreatePoModal from "src/Pages/WO/Components/createpomodal/CreatePoModal";
import EditButton from "./Components/editbutton";
import History from "./Components/history/history";
import PreviewSTModal from "./Components/previewstmodal";
import BlueServiceTicketButton from "./Components/serviceticketbuttons/blueserviceticketbutton";
import ServiceTicketButton from "./Components/serviceticketbuttons/serviceticketbutton";
import PDFPreviewModal from "./Components/pdfpreview";
import ConfirmDialog from "src/Common/confirmdialog";
import WoType from "src/Pages/WO/Components/Types/WoType";
import ApproveModal from "./Components/ApproveModal";
import Notes from "./Components/notes";
import NoteService from "src/Services/API/note.service";
import ViewButton from "./Components/attachment/ViewButton";
import Pos from "./Components/pos/Pos";
import Timesheet from "./Components/timesheet/Timesheet";
import CollapsableComponent from "./Components/CollapsableComponent";
import AdminNotes from "./Components/adminnote/AdminNotes";
import TechNotes from "./Components/technote/TechNotes";
import FormBuilderComponent from "./Components/forms/FormBuilderComponent";
import FormViewerModal from "./Components/forms/FormViewerModal";
import FormCreateModal from "./Components/forms/FormCreateModal";
import AddFormModal from "./Components/forms/AddFormModal";
import WOFormService from "src/Services/API/woform.service";

function WODetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentUser = UserService.getCurrentUser();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [editingPO, setEditingPO] = useState(null);
  const [isAssignTechModalShown, setIsAssignTechModalShown] = useState(false);
  const attachmentFile = useRef(null);
  const proposalFile = useRef(null);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [cratePOModalShown, setCratePOModalShown] = useState(false);
  const [approveModalShown, setApproveModalShown] = useState(false);
  const [stPreviewModalShown, setSTPreviewModalShown] = useState(false);
  const [stPreviewLoading, setStPreviewLoading] = useState(false);
  const [isWoCreateOpen, setIsWoCreateOpen] = useState(false);
  //billed date
  // const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [billedDateModalShown, setBilledDateModalShown] = useState(false);
  const [formViewerModalShown, setFormViewerModalShown] = useState(false);
  const [formCreateModalShown, setFormCreateModalShown] = useState(false);
  const [addFormModalShown, setAddFormModalShown] = useState(false);

  //image preview
  const [isImageViewerShown, setIsImageViewerShown] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [previewImageActiveIndex, setPreviewImageActiveIndex] = useState(0);

  //pdf preview
  const [isPDFViewerShown, setIsPDFViewerShown] = useState(false);
  const [previewPDFs, setPreviewPDFs] = useState([]);
  const [previewPDFActiveIndex, setPreviewPDFActiveIndex] = useState(0);
  //attachment delete confirmation
  const [attachmentDeleteModalShown, setAttachmentDeleteModalShown] = useState(false);
  // const [attachmentToDeleteIndex, setAttachmentToDeleteIndex] = useState(-1);
  const [attachmentToDelete, setAttachmentToDelete] = useState(null);
  //proposal delete confirmation
  const [proposalDeleteModalShown, setProposalDeleteModalShown] = useState(false);
  const [proposalToDeleteIndex, setProposalToDeleteIndex] = useState(-1);

  const [isUploadingAttachment, setIsUploadingAttachment] = useState(false);
  const [isUploadingProposal, setIsUploadingProposal] = useState(false);

  //forms
  // const [isFormBuilderModalShown, setIsFormBuilderModalShown] = useState(false);

  const isPdfFile = (fileName) => fileName && fileName.toLowerCase().endsWith(".pdf");

  const handleAttachmentClick = (attachment) => {
    if (!order?.attachments?.length) return;

    if (isPdfFile(attachment.fileName)) {
      const pdfFiles = [];
      let activeIndex = 0;

      for (const item of order.attachments) {
        if (isPdfFile(item.fileName)) {
          if (item.id === attachment.id) {
            activeIndex = pdfFiles.length;
          }
          pdfFiles.push(item.fileName);
        }
      }

      setPreviewPDFs(pdfFiles);
      setPreviewPDFActiveIndex(activeIndex);
      setIsPDFViewerShown(true);
    } else {
      const imageFiles = [];
      let activeIndex = 0;

      for (const item of order.attachments) {
        if (!isPdfFile(item.fileName)) {
          if (item.id === attachment.id) {
            activeIndex = imageFiles.length;
          }
          imageFiles.push({ src: getUploadUrl(item.fileName), alt: "" });
        }
      }

      setPreviewImages(imageFiles);
      setPreviewImageActiveIndex(activeIndex);
      setIsImageViewerShown(true);
    }
  };

  const handleAttachmentDownload = (attachment) => {
    if (isPdfFile(attachment.fileName)) {
      downloadPdf(getUploadUrl(attachment.fileName), getRealFileName(attachment.fileName));
    } else {
      downloadImage(getUploadUrl(attachment.fileName), getRealFileName(attachment.fileName));
    }
  };

  useEffect(() => {
    WOService.getWorkOrderById(id)
      .then((response) => {
        if (response.status == 200) {
          setOrder(response.data);
          dispatch(setWONumber(String(response.data.number)));
        }
      })
      .catch((error) => handleError(error));
  }, [id]);

  const approveRequest = (number, serviceType, startDate, primaryTech) => {
    let data = {};

    data = {
      status: 1,
      number: number,
      serviceType: serviceType,
      openDate: new Date(),
      openUser: currentUser,
      eventUser: currentUser,
    };

    if (startDate) {
      data.startDate = formatDate(startDate, "YYYY-MM-DD");
    }

    WOService.update({
      id: order.id,
      data,
    })
      .then(async (response) => {
        console.log("approveRequest: ", response.data);
        if (response.status == 201) {
          if (primaryTech) {
            try {
              await TechnicianService.createTechnician({
                woId: response.data.id,
                data: [{ user: primaryTech.id, roleId: 0 }],
                eventUser: currentUser,
              });
            } catch (error) {
              handleError(error);
            }
          }
          getWODetail(order.id);
          toast("Work order approved successfully");
          setApproveModalShown(false);
          dispatch(setWONumber(String(number)));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const denyRequest = () => { };

  const saveAssigns = async (dataParam) => {
    let data = dataParam.filter((item) => item.user !== -1 && item.roleId !== -1);
    setIsAssignTechModalShown(false);

    if (order.assignedTechs.length > 0) {
      let alreadyAssignedTechs = [];
      for (let item of order.assignedTechs) {
        alreadyAssignedTechs.push({ user: item.user.id, roleId: item.roleId });
      }
      console.log("Old Assigned Techs: ", alreadyAssignedTechs);
      console.log("New Assigned Techs: ", data);

      let newTechArray = [],
        removedTechArray = [],
        updatedTechArray = [];
      for (let item of data) {
        if (!alreadyAssignedTechs.some((obj) => obj.user === item.user)) {
          newTechArray.push(item);
        }
        if (alreadyAssignedTechs.some((obj) => obj.user === item.user && obj.roleId !== item.roleId)) {
          updatedTechArray.push(item);
        }
      }

      for (let item of alreadyAssignedTechs) {
        if (!data.some((obj) => obj.user === item.user)) {
          removedTechArray.push(item);
        }
      }

      await TechnicianService.createTechnician({
        woId: order.id,
        data: newTechArray,
        eventUser: currentUser,
      });
      await TechnicianService.deleteTechnician({
        woId: order.id,
        data: removedTechArray,
        eventUser: currentUser,
      });
      await TechnicianService.updateBulkTechnician({
        woId: order.id,
        data: updatedTechArray,
      });
    } else {
      TechnicianService.createTechnician({
        woId: order.id,
        data,
        eventUser: currentUser,
      })
        .then((response) => {
          console.log("response: ", response);
          if (response.status == 201) {
            console.log("new order: ", {
              ...order,
              assignedTechs: response.data,
            });
            setOrder({ ...order, assignedTechs: response.data });
            toast("Techs assigned successfully");
          } else {
            toast("An error occured");
          }
        })
        .catch((error) => {
          handleError(error);
        });
    }
    getWODetail(order.id);
  };

  const fileSelected = async (type, e) => {
    const files = e.target.files;

    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    if (type === 1) {
      setIsUploadingAttachment(true);
    } else if (type === 2) {
      setIsUploadingProposal(true);
    }
    if (files) {
      let compressedFiles = [];
      for (let file of files) {
        const isImage = file.type.startsWith("image/");
        if (isImage && file.size > 5242880) {
          const compressedBlob = await imageCompression(file, options);
          const compressedFile = new File(
            [compressedBlob],
            file.name,
            {
              type: compressedBlob.type,
              lastModified: Date.now(),
            }
          );
          compressedFiles.push(compressedFile);

          console.log("Original:", file.size / 1024 / 1024, "MB");
          console.log("Compressed:", compressedFile.size / 1024 / 1024, "MB");
        } else {
          compressedFiles.push(file);
        }
      }

      WOService.uploadFiles(compressedFiles, order.id, type, currentUser)
        .then((response) => {
          if (response.status == 201) {
            toast("file uploaded successfully");
            let temp = { ...order };
            if (type === 1) {
              temp.attachments = response.data;
            } else if (type === 2) {
              temp.proposals = response.data;
            }
            setOrder(temp);
          } else {
            toast("Something went wrong");
          }
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          if (type === 1) {
            setIsUploadingAttachment(false);
          } else if (type === 2) {
            setIsUploadingProposal(false);
          }
        });
    }
  };

  const saveScheduledStartTargetDate = (startDate, targetDate) => {
    setIsScheduleModalOpen(false);
    if (!startDate && !targetDate) return;
    let data = {};
    if (startDate) {
      data["scheduledStartDate"] = startDate;
      // data["startDateForTimesheet"] = startDate.format("YYYY-MM-DD HH:mm:ss");
    }
    if (targetDate) {
      data["scheduledTargetDate"] = targetDate;
    }

    WOService.update({ id: order.id, data: data })
      .then((response) => {
        console.log("saveStartTargetDate: ", response);
        if (response.status == 201) {
          setOrder(response.data);
          toast("Date saved successfully");
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const saveBilledDate = (date, billedNote) => {
    setBilledDateModalShown(false);

    let billedData = order.billedData;
    if (billedData) {
      billedData.push({
        date: formatDate(date, "MM/DD/YYYY"),
        note: billedNote,
      });
    } else {
      billedData = [{ date: formatDate(date, "MM/DD/YYYY"), note: billedNote }];
    }

    WOService.update({
      id: order.id,
      data: { billedData, eventUser: currentUser },
    })
      .then((response) => {
        console.log("saveBilledtDate: ", response);
        if (response.status == 201) {
          setOrder(response.data);
          toast("Billed date saved successfully");
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  // const uploadClicked = () => {
  //   inputFile.current.click();
  // };

  const navigatePODetail = (po) => {
    POService.getPurchaseOrdersByPoId(po.id)
      .then((response) => {
        if (response.status == 200) {
          navigate("/purchase/" + response.data.number, {
            state: { order: response.data },
          });
        }
      })
      .catch((error) => handleError(error));
  };

  const createPO = () => {
    setEditingPO(null);
    setCratePOModalShown(true);
  };

  const getWODetail = (id) => {
    WOService.getWorkOrderById(id)
      .then((response) => {
        console.log("save assigned techs: ", response);
        if (response.status == 200) {
          setOrder(response.data);
        }
      })
      .catch((error) => handleError(error));
  };

  const savePO = async (data) => {
    setCratePOModalShown(false);

    if (editingPO) {
      try {
        //upload receipts
        // for (let file of data.data.receipts) {
        //   const fileName = `PO receipt_${String(Math.floor(Date.now()))}.png`;
        //   const fileData = { id: data.id, name: fileName, base64: file.base64 };
        //   console.log(fileData);
        //   await POService.attachFile(fileData);
        // }

        //save data
        let response = await POService.update(data);
        if (response.status == 201) {
          toast("Purchase order updated successfully!");
          getWODetail(order.id);
        }
      } catch (error) {
        handleError(error);
      }
    } else {
      POService.savePurchaseOrder(data)
        .then((response) => {
          if (response.status == 201) {
            toast("Purchase order created successfully!");

            // if (order.pos.length === 0) {
            //   WOService.update({ id: order.id, data: { status: 4 } })
            //     .then((response) => {
            //       console.log("status update: ", response);
            //       if (response.status == 201) {
            //         setOrder(response.data);
            //       }
            //     })
            //     .catch((error) => {
            //       handleError(error);
            //     });
            // } else {
            WOService.getWorkOrderById(order.id)
              .then((response) => {
                console.log("response: ", response);
                if (response.status == 200) {
                  setOrder(response.data);
                }
              })
              .catch((error) => handleError(error));
            // }
          }
        })
        .catch((error) => {
          handleError(error);
        });
    }
  };

  const showPreviewModal = () => {
    setStPreviewLoading(true);
    WOService.previewServiceTicket(order.id)
      .then((response) => {
        if (response.status == 200) {
          setSTPreviewModalShown(true);
        }
      })
      .catch((error) => {
        handleError(error);
      })
      .finally(() => {
        setStPreviewLoading(false);
      });

    // WOService.attachMaterials({ id: order.id, data: {} })
    //   .then((response) => {
    //     console.log(response.status);
    //     if (response.status == 201) {
    //     }
    //   })
    //   .catch((error) => handleError(error));
  };

  const closeWorkOrder = () => {
    WOService.update({ id: order.id, data: { status: 100 } })
      .then((response) => {
        console.log("status update to CLOSE: ", response);
        if (response.status == 201) {
          setOrder(response.data);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleScheduleEdit = () => {
    setIsScheduleModalOpen(true);
  };

  const saveWO = (data) => {
    setIsWoCreateOpen(false);
    WOService.update({
      id: order.id,
      data: { ...data, eventUser: currentUser },
    })
      .then((response) => {
        console.log("response: ", response);
        if (response.status == 201) {
          toast("Work order created successfully");
          setOrder(response.data);
          dispatch(setWONumber(String(response.data.number)));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const poEditHandle = (po) => {
    console.log(po);
    setCratePOModalShown(true);
    setEditingPO(po);
  };

  const handleAssignedTechsEdit = () => {
    setIsAssignTechModalShown(true);
  };

  const deleteUpload = (type) => {
    setAttachmentDeleteModalShown(false);
    setProposalDeleteModalShown(false);
    WOService.deleteAttachment(order.id, type === 1 ? attachmentToDelete.id : proposalToDeleteIndex, type)
      .then((response) => {
        console.log("🚀 ~ deleteUpload ~ response:", response)
        toast("Attachment deleted successfully");
        getWODetail(order.id);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const sendNote = (message) => {
    const data = {
      wo: order,
      message,
      sender: currentUser,
      senderType: 0
    };

    NoteService.createNote(data).then((response) => {
      toast("Note sent successfully");
      setOrder({ ...order, customerNotes: [...order.customerNotes, response.data] });
    });
  };

  const handleFormUnassign = () => {
    return WOFormService.findAll(id)
      .then((response) => {
        if (response.status == 200) {
          const forms = response.data || [];
          setOrder((prev) => ({ ...prev, forms }));
          if (!forms.length) {
            setFormViewerModalShown(false);
          }
        }
      })
      .catch((error) => handleError(error));
  };

  const handleFormView = () => {
    if (!order?.forms?.length) return;

    WOFormService.findAll(id)
      .then((response) => {
        if (response.status == 200) {
          const forms = response.data || [];
          setOrder((prev) => ({ ...prev, forms }));
          if (forms.length) {
            setFormViewerModalShown(true);
          }
        }
      })
      .catch((error) => handleError(error));
  };

  return order ? (
    <div className="w-full px-5 ">
      <AssignTechModal
        shown={isAssignTechModalShown}
        onCancelClicked={() => setIsAssignTechModalShown(false)}
        onSaveClicked={saveAssigns}
        assignedTechs={order.assignedTechs}
        branch={order.branch}
      />
      <ScheduleModal
        shown={isScheduleModalOpen}
        pStartDate={order.scheduledStartDate}
        pTargetDate={order.scheduledTargetDate}
        onSaveClicked={saveScheduledStartTargetDate}
        onCancel={() => setIsScheduleModalOpen(false)}
      />
      <CreatePoModal
        shown={cratePOModalShown}
        onCancelClicked={() => setCratePOModalShown(false)}
        onSubmitClicked={savePO}
        wo={order}
        editingPO={editingPO}
      />
      <PreviewSTModal
        shown={stPreviewModalShown}
        pdfUrl={getServiceTicketUrl(order.number)}
        cancelClicked={() => setSTPreviewModalShown(false)}
      />
      <CreateWoModal
        order={order}
        onSubmitClicked={saveWO}
        shown={isWoCreateOpen}
        onCancelClicked={() => setIsWoCreateOpen(false)}
      />
      <Viewer
        visible={isImageViewerShown}
        onClose={() => {
          setIsImageViewerShown(false);
        }}
        images={previewImages}
        activeIndex={previewImageActiveIndex}
      />
      <PDFPreviewModal
        PDFs={previewPDFs}
        activeIndex={previewPDFActiveIndex}
        shown={isPDFViewerShown}
        onCancel={() => setIsPDFViewerShown(false)}
      />

      <BilledDateModal
        shown={billedDateModalShown}
        onCancel={() => setBilledDateModalShown(false)}
        pBilledDate={order.billedDate}
        pBilledNote={order.billedNote}
        onSaveClicked={(date, note) => {
          saveBilledDate(date, note);
        }}
      />

      <ConfirmDialog
        title="DELETE ATTACHMENT"
        description="Are you sure you want to delete this attachment?"
        shown={attachmentDeleteModalShown}
        onConfirmClicked={() => deleteUpload(1)}
        onCancelClicked={() => setAttachmentDeleteModalShown(false)}
      />

      <ConfirmDialog
        title="DELETE PROPOSAL/ESTIMATE"
        description="Are you sure you want to delete this proposal/estimate?"
        shown={proposalDeleteModalShown}
        onConfirmClicked={() => deleteUpload(2)}
        onCancelClicked={() => setProposalDeleteModalShown(false)}
      />

      <ApproveModal
        shown={approveModalShown}
        onCancelClicked={() => setApproveModalShown(false)}
        onApproveClicked={approveRequest}
      />

      <div className="w-full h-[56px] flex items-center justify-between ">
        <div className="flex items-center cursor-pointer" onClick={() => navigate("/work")}>
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
        <div className="flex items-center gap-3">
          {(isClericalOver() || isAccountant()) && <CreateButton title="CREATE PO" onClicked={createPO} />}
          {order.status === 6 && (isClericalOver() || isAccountant()) && (
            <BlueButton title="CLOSE WORK ORDER" onClicked={closeWorkOrder} />
          )}
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor">
        <div className="w-full h-[30px]  flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Customer Information</span>
        </div>
        <div className="w-full h-[50px] border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3">
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Company</p>
            <p className="font-OpenSansRegular  text-[10px] text-titleColor">{order.customer.companyName}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Email</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">{order.customer.email}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Contact</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">{order.customer.contact}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Phone Number</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">{order.customer.phone}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Address</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">{order.customer.address}</p>
          </div>
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor mt-3 ">
        <div className="w-full h-[30px]  flex items-center justify-between px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Service Call</span>
          <WOStatusComponent value={order.status} />
        </div>
        <div className="w-full h-[50px] border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3 gap-[150px]">
          <div className="w-full flex items-center justify-between">
            <div>
              <WoType serviceType={order.serviceType} />
            </div>
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Opened On:</span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">
                {order.openDate ? formatDate(order.openDate) : ""}
              </span>
            </div>

            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Start date:</span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">
                {order.startDateString && order.startDateString}
              </span>
            </div>

            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">NTE:</span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.NTE && `$${order.NTE}`}</span>
            </div>
            {order.status == 0 ? (
              <div className="flex items-center gap-1">
                <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Requested by:</span>
                {order.requestedCustomerUser && (
                  <>
                    <img
                      src={getAvatarUrl(order.requestedCustomerUser.avatar)}
                      className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                    />
                    <span className="font-OpenSansRegular font-[400] text-[12px] text-subTitleColor ">
                      {order.requestedCustomerUser.name}
                    </span>
                  </>
                )}
              </div>
            ) : (
              <div className="flex items-center gap-1">
                <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Issued by:</span>
                <img
                  src={getAvatarUrl(order.openUser?.avatar)}
                  className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                  alt=""
                />
                <span className="font-OpenSansRegular font-[400] text-[12px] text-subTitleColor ">
                  {order.openUser?.name}
                </span>
              </div>
            )}
            {order.quotedBy && (
              <div className="flex items-center gap-1">
                <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Quoted by:</span>
                <img
                  src={getAvatarUrl(order.quotedBy.avatar)}
                  className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                />
                <span className="font-OpenSansRegular font-[400] text-[12px] text-subTitleColor ">
                  {order.quotedBy.name}
                </span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-2">
            {(isClericalOver() || isAccountant()) && <PencilButton clicked={() => setIsWoCreateOpen(true)} />}
            {(isClericalOver() || isAccountant()) &&
              (order.status >= 5 ? (
                <BlueServiceTicketButton clicked={() => navigate("/serviceticket", { state: { order: order } })} />
              ) : (
                <ServiceTicketButton clicked={showPreviewModal} isLoading={stPreviewLoading} />
              ))}
          </div>
        </div>
        <div className="w-full flex items-start justify-between px-3 py-3">
          <div className="w-[35%] flex flex-col ">
            <div className="flex items-center gap-2 mb-2">
              <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Asset:</p>
              <p className="font-OpenSansReg ular text-[12px] text-titleColor break-all">{order.asset}</p>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Customer Purchase Order #:</p>
              <p className="font-OpenSansReg ular text-[12px] text-titleColor break-all">{order.customerPONumber}</p>
            </div>
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Description</p>
            <p className="font-OpenSansReg ular text-[12px] text-titleColor break-all">{order.description}</p>
          </div>
          <div className="w-[65%] flex items-start justify-around gap-8 relative">
            <div className="w-[30%] flex flex-col ">
              {/* <div className="w-full flex items-center justify-between mb-1">
                  <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor ">Schedule</p>
                  {(order.scheduledStartDate || order.scheduledTargetDate) && (isClericalOver() || isAccountant()) && (
                    <EditButton clicked={handleScheduleEdit} />
                  )}
                </div>

                {order.scheduledStartDate || order.scheduledTargetDate ? (
                  <>
                    <div className="w-full h-[25px] flex items-center gap-1">
                      <img src={getImageUrl("/images/wo/date.png")} />
                      {order.scheduledStartDate && (
                        <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
                          {formatDate(order.scheduledStartDate)}
                        </p>
                      )}
                    </div>

                    <div className="w-full h-[25px] flex items-center gap-1">
                      <img src={getImageUrl("/images/wo/date-target.png")} />
                      {order.scheduledTargetDate && (
                        <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
                          {formatDate(order.scheduledTargetDate)}
                        </p>
                      )}
                    </div>
                  </>
                ) : (
                  <div
                    onClick={() => setIsScheduleModalOpen(true)}
                    className="cursor-pointer h-[30px] w-[100px] rounded-[6px] border-solid border-borderColor border-[1px] flex items-center justify-center"
                  >
                    <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">SCHEDULE</span>
                  </div>
                )} */}

              <div className="w-full flex items-center justify-between mb-3 ">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor ">Date Billed</p>
              </div>
              <div className="w-full flex flex-col flex-auto overflow-y-auto gap-2 max-h-[220px]">
                {order.billedData &&
                  order.billedData.map((item, index) => (
                    // <div className="w-full h-full ">
                    <div className="w-[full] flex flex-col  " key={index}>
                      <div className="flex items-center gap-1">
                        <img src={getImageUrl("/images/wo/date.png")} />
                        <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">{item.date}</p>
                      </div>
                      <span className="text-[12px] font-OpenSansMedium font-[400] text-titleColor word-break-break-word">
                        {`Note: ${item.note}`}
                      </span>
                    </div>
                    // </div>
                  ))}
              </div>
              {(isClericalOver() || isAccountant()) && order.status >= 1 && (
                <div
                  onClick={() => setBilledDateModalShown(true)}
                  className="cursor-pointer w-[100px] h-[30px] rounded-[6px] border-solid border-borderColor border-[1px] flex items-center justify-center mt-2"
                >
                  <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">ADD</span>
                </div>
              )}
            </div>
            <div className="w-[30%] items-start flex flex-col">
              <div className="w-full flex items-center justify-between mb-3">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Assigned To:</p>
              </div>
              <div className="flex flex-col gap-2">
                {order.assignedTechs?.length > 0 && (
                  <div className="w-full h-full overflow-auto max-h-[200px]">
                    {order.assignedTechs.map((tech, index) => {
                      return (
                        <div className="w-full h-[25px] flex items-center gap-2" key={index}>
                          <img src={getAvatarUrl(tech.user.avatar)} className="w-[16px] h-[16px] rounded-[8px]" />
                          <span className="font-OpenSansRegular font-[400] text-[11px] text-titleColor">
                            {tech.user.name}
                          </span>
                          {tech.status === 1 ? (
                            <img src={getImageUrl("/images/common/check.png")} className="w-[20px] h-[20px]" />
                          ) : tech.status === 2 ? (
                            <img src={getImageUrl("/images/common/red_close.png")} className="w-[20px] h-[20px]" />
                          ) : (
                            <></>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
                <div>
                  {(order.status > 0 || (isClericalOver() || isAccountant())) && (
                    order.assignedTechs?.length > 0 ? (
                      (
                        <EditButton clicked={handleAssignedTechsEdit} />
                      )
                    ) : (
                      <div
                        onClick={() => setIsAssignTechModalShown(true)}
                        className="cursor-pointer w-[100px] h-[30px] rounded-[6px] border-solid border-borderColor border-[1px] flex items-center justify-center"
                      >
                        <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">ASSIGN</span>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="w-[40%] flex flex-col gap-4">
              {/* Attachments */}
              <div className="w-full flex flex-col">
                <input
                  onChange={(e) => fileSelected(1, e)}
                  type="file"
                  id="file"
                  ref={attachmentFile}
                  style={{ display: "none" }}
                  multiple={true}
                  accept="image/*,application/pdf"
                />
                <div className="w-full flex items-center justify-between h-[30px]">
                  <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Attachments: {order.attachments?.length > 0 ? `(${order.attachments?.length})` : ""}</p>

                </div>

                <div className="flex items-center gap-2">
                  <WhiteUploadButton isLoading={isUploadingAttachment} clicked={() => attachmentFile.current.click()} />
                  <ViewButton isBlue={order.attachments?.length > 0} clicked={() => { order.attachments?.length > 0 && navigate(`/work/${order.id}/attachments`, { state: { woId: order.id } }) }} />
                </div>


              </div>
              {/* proposals */}
              {(isManagerOver() || isAccountant()) && (
                <div className="w-full flex flex-col">
                  <input
                    onChange={(e) => fileSelected(2, e)}
                    type="file"
                    id="file"
                    ref={proposalFile}
                    style={{ display: "none" }}
                    multiple={true}
                    accept="image/*,application/pdf"
                  />
                  <div className="w-full flex items-center justify-between h-[30px]">
                    <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Proposal/Estimate:</p>
                  </div>
                  <div className="flex flex-col gap-2">
                    {order.proposals && order.proposals?.length > 0 && (
                      <div className="w-full h-full flex-auto overflow-y-auto max-h-[140px]">
                        {order.proposals.map((file, index) => {
                          return (
                            <div className="w-full h-[25px] flex items-center gap-3 " key={index}>
                              <span
                                onClick={() => {
                                  if (file.split(".").pop().toLowerCase() === "pdf") {
                                    let temp = [];
                                    for (let proposal of order.proposals) {
                                      if (proposal.split(".").pop().toLowerCase() === "pdf") {
                                        temp.push(proposal);
                                        if (proposal === file) {
                                          setPreviewPDFActiveIndex(temp.length - 1);
                                        }
                                      }
                                    }
                                    setPreviewPDFs(temp);
                                    setIsPDFViewerShown(true);
                                  } else {
                                    let temp = [];
                                    for (let proposal of order.proposals) {
                                      if (proposal.split(".").pop().toLowerCase() !== "pdf") {
                                        temp.push({ src: getUploadUrl(proposal), alt: "" });
                                        if (proposal === file) {
                                          setPreviewImageActiveIndex(temp.length - 1);
                                        }
                                      }
                                    }
                                    setPreviewImages(temp);
                                    setIsImageViewerShown(true);
                                  }
                                }}
                                className="font-OpenSansRegular font-[400] text-[11px] text-titleColor cursor-pointer"
                              >
                                {getRealFileName(file)}
                              </span>
                              <div className="flex items-center gap-2">
                                <div
                                  onClick={() => {
                                    if (file.split(".").pop().toLowerCase() === "pdf") {
                                      downloadPdf(getUploadUrl(file), getRealFileName(file));
                                    } else {
                                      downloadImage(getUploadUrl(file), getRealFileName(file));
                                    }
                                  }}
                                  className="cursor-pointer"
                                >
                                  <FaDownload color="#010D3D" size={13} />
                                </div>
                                {isManagerOver() && (
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => {
                                      setProposalDeleteModalShown(true);
                                      setProposalToDeleteIndex(index);
                                    }}
                                  >
                                    <MdDelete color="#010D3D" size={16} />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>

                    )}
                    {(isClericalOver() || isAccountant()) && (
                      <WhiteUploadButton isLoading={isUploadingProposal} clicked={() => proposalFile.current.click()} />
                    )}
                  </div>
                  <div className="w-full flex items-center justify-between h-[30px] mt-2">
                    <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Forms {order.forms?.length > 0 ? `(${order.forms?.length})` : ""}:</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <div
                      onClick={() => setAddFormModalShown(true)}
                      className="cursor-pointer w-[100px] h-[30px] rounded-[6px] border-solid border-borderColor border-[1px] flex items-center justify-center"
                    >
                      <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">ADD</span>
                    </div>
                    <ViewButton isBlue={order.forms?.length > 0} clicked={handleFormView} />
                  </div>
                  <AddFormModal
                    shown={addFormModalShown}
                    woId={order.id}
                    onClose={() => setAddFormModalShown(false)}
                    onAssignForm={(formId) => {
                      WOFormService.update(formId, { wo: { id: order.id }, status: 1 })
                        .then((res) => {
                          if (res.status === 200) {
                            toast("Form assigned successfully");
                            setAddFormModalShown(false);
                            WOService.getWorkOrderById(id)
                              .then((r) => { if (r.status == 200) setOrder(r.data); })
                              .catch((err) => handleError(err));
                          }
                        })
                        .catch((err) => handleError(err));
                    }}
                    onCreateForm={() => {
                      setAddFormModalShown(false);
                      setFormCreateModalShown(true);
                    }}
                  />
                  <FormCreateModal
                    shown={formCreateModalShown}
                    woId={order.id}
                    onClose={() => setFormCreateModalShown(false)}
                  />
                  <FormViewerModal
                    shown={formViewerModalShown}
                    title="PREVIEW FORM"
                    forms={order.forms || []}
                    onUnassign={handleFormUnassign}
                    onClose={() => setFormViewerModalShown(false)}
                  />
                </div>
              )}
            </div>
          </div>
          {order.status == 0 && (isManagerOver() || isAccountant()) && (
            <div className="w-[50%] h-[100px] flex items-center justify-end">
              <div className="flex flex-col items-center gap-1">
                <ApproveRequestButton onClicked={() => setApproveModalShown(true)} />
                <DenyRequestButton onClicked={denyRequest} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex mt-3 justify-between">
        {/* {order.history && order.history.length > 0 && ( */}
        <div className="w-[49%] ">
          {/* <div className="w-full border-solid border-[1px] border-borderColor mb-3">
            <div className="w-full h-[30px]  flex items-center px-3">
              <span className="font-family-OpenSansRegular font-[700] text-[16px] text-titleColor ">Notes</span>
            </div>
            <div className="w-full border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3 py-3">
              <Notes notes={order.customerNotes} sendNote={sendNote} />
            </div>
          </div> */}

          <CollapsableComponent title="Customer Chat" defaultOpen={false} toolTip="This is a direct line of communication between you and the customer.<br/> However the customer will not receive your messages unless they are set up on the Customer App.">
            <Notes notes={order.customerNotes} sendNote={sendNote} />
          </CollapsableComponent>
          <div className="h-5" />
          <CollapsableComponent title="Admin Notes" defaultOpen={false} toolTip="This is a place make a quick note for users on the Browser App only. Viewable by all admins and accountants.">
            <AdminNotes woId={order.id} />
          </CollapsableComponent>
          <div className="h-5" />
          <CollapsableComponent title="Tech Notes" defaultOpen={false} toolTip="This is a place to make a quick note for users on both the Browser and Tech Apps. Viewable by all.">
            <TechNotes woId={order.id} />
          </CollapsableComponent>

          {/* <div className="w-full border-solid border-[1px] border-borderColor">
              <div className="w-full h-[30px]  flex items-center px-3">
                <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">History</span>
              </div>
              <div className="w-full border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3 py-3">
                {order.history && <History historyData={order.history} />}
              </div>
            </div> */}
        </div>
        {/* )} */}
        <div className="w-[49%] flex flex-col gap-5">
          <CollapsableComponent title="Purchase Orders" defaultOpen={false}>
            <Pos
              woId={order.id}
              navigatePODetail={navigatePODetail}
              poEditHandle={poEditHandle}
              setPreviewImages={setPreviewImages}
              setPreviewImageActiveIndex={setPreviewImageActiveIndex}
              setIsImageViewerShown={setIsImageViewerShown}
            />
          </CollapsableComponent>
          <CollapsableComponent title="Timesheet" defaultOpen={false}>
            <Timesheet order={order} />
          </CollapsableComponent>
          <CollapsableComponent title="History" defaultOpen={false}>
            <History woId={order.id} />
          </CollapsableComponent>
        </div>
        {/* </div> */}
      </div>
    </div>
  ) : (
    <div className="flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <Oval
        height={50}
        width={50}
        strokeWidth={2}
        color="#010D3D"
        secondaryColor="#80869E"
        ariaLabel="oval-loading"
        visible={true}
      />
    </div>
  );
}

export default WODetail;
